import { Injectable } from '@angular/core';
import { NetService } from './net.service';
import { environment } from 'apps/support/src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CandidateService {

constructor(
  private netService: NetService
) { }


  candidateLogin(body: any) {
    return this.netService.postJavaCandidateLogin('candidate/login-candidate', body)
  }

  candidateSendCode(body: any,userId: string) {
    return this.netService.postJavaCandidateLogin(`candidate/sign-in-candidate/${userId}`, body)
  }

  getCandidateData(userId: string | undefined) {
    return this.netService.getJavaUser(`self-showing/get-self-showing-by-candidate-id?candidateId=${userId}&includeDeleted=true&userId=${userId}`)
  }

  getDataByPropertyIds(propertyIds: string) {
    return this.netService.getJavaNoHeaders(`marketing/property/find-all-available-for-rent-by-propertyIds?propertyIds=${propertyIds}&userId=${environment.fixetUserId}`)
  }


  checkInOutShowing(type: string,scheduleId: string | undefined) {
    return this.netService.postJavaCandidateText(`candidate/${type}-candidate?scheduleId=${scheduleId}`)
  }

  deleteSelfShowing(scheduleId: string | undefined,userId: string | undefined) {
    return this.netService.deleteJavaApplicant(`self-showing/delete-self-showing?id=${scheduleId}&userId=${userId}`)
  }

  upadteSelfShowing(body: any) {
    return this.netService.putJavaApplicant(`self-showing/update-self-showing?userId=${environment.fixetUserId}`, body)
  }

  updateCandidateData(body: any,userId: any) {
    return this.netService.putJavaApplicant(`candidate/update-candidate?candidateId=${userId.toLowerCase()}&userId=${userId}`, body)
  }

}
